import { JSONSchema7 } from "json-schema";

export const jsonSchema7Types = [
  "string",
  "number",
  "integer",
  "boolean",
  "object",
  "array",
  "null",
] as const;
export type JsonSchema7Type = (typeof jsonSchema7Types)[number];

export interface JsonSchema7Property {
  id: string;
  name: string;
  type: JsonSchema7Type;
  description?: string;
  title?: string;
  required?: boolean;
  properties?: JsonSchema7Property[];
  items?: JsonSchema7Property;
  validation?: PropertyValidation;
  enum?: (string | number | boolean | null)[];
  const?: string | number | boolean | null;
  default?: string | number | boolean | null;
  examples?: (string | number | boolean | null)[];
}

export interface PropertyValidation {
  // String validation
  minLength?: number;
  maxLength?: number;
  pattern?: string;

  // Number validation
  minimum?: number;
  maximum?: number;
  exclusiveMinimum?: number;
  exclusiveMaximum?: number;
  multipleOf?: number;

  // Array validation
  minItems?: number;
  maxItems?: number;
  uniqueItems?: boolean;

  // Object validation
  minProperties?: number;
  maxProperties?: number;

  // General validation
  format?: string;
}

export interface JsonSchema7BuilderProps {
  schema?: JSONSchema7;
  onChange: (schema: JSONSchema7) => void;
  title?: string;
  className?: string;
}

export interface PropertyEditorProps {
  property: JsonSchema7Property;
  onChange: (property: JsonSchema7Property) => void;
  onDelete: () => void;
  depth?: number;
  parentId?: string;
}

export interface TypeSelectorProps {
  value: JsonSchema7Type;
  onChange: (type: JsonSchema7Type) => void;
}

export interface ValidationEditorProps {
  validation: PropertyValidation;
  type: JsonSchema7Type;
  onChange: (validation: PropertyValidation) => void;
}

export interface SchemaPreviewProps {
  schema?: JSONSchema7;
}
